import {checkDomain, formatDelay} from './check-domains'
import {request} from '@/util/scripts/request'
import service from '@/business/webcheck/scripts/service'

const GetFailed = '获取失败'
const ConnectFailed = '连接失败'

export function checkSubmitDomain(domain, cb) {
  let resultObj = {target: domain}
  return Promise.all([
    //服务器拨测->前端测试
    new Promise(resolve => {
      request(service.probe, {domain})
        .then(({success, result}) => {
          if (success) {
            let {http, https, code, description} = result
            //服务器拨测 返回 domain.ping, domain.http, domain.https
            let r = {
              ping: `${code} ${description}`,
              http: http ? '开启' : '未知',
              https: https ? '开启' : '未知'
            }
            cb(r)
            Object.assign(resultObj, r)
            //前端检测 获取 domain.delay
            checkDomain(domain, (domain, delay, type) => cb({delay: formatDelay({delay, type})}))
              .then(({domain, delay}) => resolve(Object.assign(resultObj, {delay})))
          }
        })
        .catch(e => {
          cb({delay: ConnectFailed, ping: ConnectFailed, http: GetFailed, https: GetFailed})
          resolve(resultObj)
        })
    }),
    //LDNS
    new Promise(resolve => {
      request(service.dns, {domain})
        .then(({success, result}) => {
          if (success) {
            let r = {ldns: result}
            cb(r)
            Object.assign(resultObj, r)
          } else cb({ldns: GetFailed})
          resolve(resultObj)
        })
        .catch(e => {
          cb({ldns: GetFailed})
          resolve(resultObj)
        })
    })
  ]).then((results) => resultObj)
}